import { Button, Message } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import ViewHippoInformationModal from '../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { isAccCoverableForOtherPerson } from '../../../utils/coverablesUtil';

const SpinOffMessage = ({
    coverable,
    title = '',
    message,
    showAccidentModal = false
}: {
    coverable: CoverableDTO;
    title?: string;
    message: string;
    showAccidentModal?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const showAccidentSpinOffMessage = isAccCoverableForOtherPerson(coverable);
    const accidentModalText = {
        title: getHippoText('DSS-COVERABLE-INFORMATION-STEP-ORDER-FOR-EXPLANATION-MODAL-HEADER'),
        description: getHippoText(
            'DSS-COVERABLE-INFORMATION-STEP-ORDER-FOR-EXPLANATION-MODAL-SUBHEADER'
        )
    };

    const [showModal, setShowModal] = useState(false);

    if (!coverable.willSpinOff) {
        return <></>;
    }

    return (
        <>
            {showAccidentSpinOffMessage ? (
                <Message theme="warning">
                    {message}
                    {showAccidentModal && (
                        <>
                            {' '}
                            <Button
                                className="flos-button"
                                theme="ghost"
                                onClick={(): void => {
                                    setShowModal(true);
                                }}
                            >
                                Læs mere her.
                            </Button>
                            <ViewHippoInformationModal
                                closeModal={() => {
                                    setShowModal(false);
                                }}
                                showModal={showModal}
                                modalProps={accidentModalText}
                            />
                        </>
                    )}
                </Message>
            ) : (
                <Message
                    theme="warning"
                    title={
                        <div
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(title)
                            }}
                        />
                    }
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(message)
                        }}
                    />
                </Message>
            )}
        </>
    );
};

export default SpinOffMessage;
